import { render, staticRenderFns } from "./PreviewPdf.vue?vue&type=template&id=1181a1d6&scoped=true"
import script from "./PreviewPdf.vue?vue&type=script&lang=js"
export * from "./PreviewPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181a1d6",
  null
  
)

export default component.exports